import DashboardIndex from '@/Libs/Pages/Panel/Dashboard/DashboardIndex.vue'
import PermissionGroupForm from '@/Libs/Pages/Panel/PermissionGroup/PermissionGroupForm.vue'
import PermissionGroupIndex from '@/Libs/Pages/Panel/PermissionGroup/PermissionGroupIndex.vue'
import ProfileIndex from '@/Libs/Pages/Panel/Auth/ProfileIndex.vue'
import VerifyEmailIndex from '@/Libs/Pages/Panel/Auth/VerifyEmailIndex.vue'
import VerifySessionIndex from '@/Libs/Pages/Panel/Auth/VerifySessionIndex.vue'

export default [
    {
        name: 'dashboard',
        path: '/dashboard',
        component: DashboardIndex,
        meta: {
            title: 'dashboard.title.list',
            permission: 'dashboard_menu'
        },
    },
    {
        name: 'permission-group',
        path: '/permission-group',
        component: PermissionGroupIndex,
        meta: {
            title: 'permission_group.title.list',
            permission: 'permission_group_list'
        },
    },
    {
        name: 'permission-group-create',
        path: '/permission-group/create',
        component: PermissionGroupForm,
        meta: {
            title: 'permission_group.title.create',
            permission: 'permission_group_create'
        },
    },
    {
        name: 'permission-group-detail',
        path: '/permission-group/detail/:id',
        component: PermissionGroupForm,
        meta: {
            title: 'permission_group.title.detail',
            permission: 'permission_group_show'
        },
    },
    {
        name: 'profile',
        path: '/profile',
        component: ProfileIndex,
        meta: {
            title: 'profile.title.detail',
            permission: 'profile_read'
        },
    },
    {
        name: 'verify-email',
        path: '/verify-email',
        component: VerifyEmailIndex,
        meta: {
            title: 'verify_email.title.detail',
            permission: null
        }
    },
    {
        name: 'verify-session',
        path: '/verify-session',
        component: VerifySessionIndex,
        meta: {
            title: 'verify_session.title.detail',
            permission: null
        }
    },
];